import { render, staticRenderFns } from "./PostFileList.vue?vue&type=template&id=2d8a26e8&scoped=true&"
import script from "./PostFileList.vue?vue&type=script&lang=ts&"
export * from "./PostFileList.vue?vue&type=script&lang=ts&"
import style0 from "./PostFileList.vue?vue&type=style&index=0&id=2d8a26e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8a26e8",
  null
  
)

export default component.exports